export const MARK_COMPANY_DELIVERY_AS_PAID = 'markCompanyDeliveryAsPaid'

export const CREATE_COMPANY_DEALER = 'createCompanyDealer'
export const UPDATE_COMPANY_DEALER = 'updateCompanyDealer'
export const DELETE_COMPANY_DEALER = 'deleteCompanyDealer'

export const GET_COMPANY_DEALERS = 'getCompanyDealers'
export const GET_COMPANY_DEALER_DELIVERIES = 'getCompanyDealerDeliveries'

export const GET_COMPANY_SHIPPINGS = 'getCompanyShippings'
export const GET_COMPANY_SHIPPING_RATES = 'getCompanyShippingRates'

export const CREATE_COMPANY_SHIPPING_RATE = 'createCompanyShippingRate'
export const UPDATE_COMPANY_SHIPPING_RATE = 'updateCompanyShippingRate'
export const DELETE_COMPANY_SHIPPING_RATE = 'deleteCompanyShippingRate'

export const GET_DELIVERY_COMPANY = 'getDeliveryCompany'
export const UPDATE_DELIVERY_COMPANY = 'updateDeliveryCompany'
export const UPDATE_DELIVERY_COMPANY_BY_ID = 'updateDeliveryCompanyById'

export const GET_LINKED_STORES = 'getLinkedStores'
export const GET_DELIVERY_COMPANIES = 'getDeliveryCompanies'

export const GET_COMPANY_SHIPPING_DETAILS = 'getCompanyShippingDetails'

export const CREATE_COMPANY_DELIVERY_RATE = 'createCompanyDeliveryRate'

export const UPDATE_DELIVERY_MODE = 'updateDeliveryMode'

export const CREATE_DELIVERY_MODE_RATE = 'updateDeliveryModeRate'

export const GET_DELIVERY_MODE_RATES = 'getDeliveryModeRates'